var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page-container"},[_c('h1',[_vm._v("Payment failed")]),_c('p',[_vm._v("Please try again in a sec")]),_c('router-link',{attrs:{"to":{name: 'orderPage'}}},[_c('i',{staticClass:"fa fa-caret-left mr-2"}),_c('span',[_vm._v("try again")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c2bc96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/PaymentFailed.vue
// module id = null
// module chunks = 